import { EmployeeDetailsPage, EmployeesCreatePage, EmployeesPage } from './views';

const routes = [
    {
        path: '/editors',
        name: 'editors',
        component: EmployeesPage,
        meta: {
            title: 'Editors',
        },
    },
    {
        path: '/editors/create',
        name: 'editors-create',
        component: EmployeesCreatePage,
        meta: {
            title: 'Create Editor',
        },
    },
    {
        path: '/editors/:id',
        name: 'editors-id',
        component: EmployeeDetailsPage,
    },
];

export default routes;
